import { render, staticRenderFns } from "./tipoGaleria.vue?vue&type=template&id=e08a0a38&scoped=true&"
import script from "./tipoGaleria.vue?vue&type=script&lang=js&"
export * from "./tipoGaleria.vue?vue&type=script&lang=js&"
import style0 from "./tipoGaleria.vue?vue&type=style&index=0&id=e08a0a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a0a38",
  null
  
)

export default component.exports